import React from 'react'
import { ENTER, HIVEBOARD } from '../assets/constants/Constants';
import { useTranslation } from 'react-i18next';
import { getSecureItemFromSpecificStorage } from '../lib/BrowserStorageAccessMiddleware';
import { LOCAL_STORAGE, LS_CUSTOMER } from '../assets/constants/BrowserStorageKeys';

export const CustomTextInput = ({
  value,
  onChange,
  type = "text",
  className = "",
  inputId = '',
  placeholder,
  multiline = false,
  handleKeyDown,
  autoFocus = true,
  rows = 3,
  inputProps = {},
  required = true,
  onEmpty,
  hasError,
  maxLength,
  disabled,
  errorMessage = null,
  placeholderClass = null,
  inputMode = 'text',
  editable = true,
  text,
  endIcon = null,
  onEndIconClick
}) => {
  const { t } = useTranslation();
  const customer = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_CUSTOMER);

  const handleKeyEvents = (event) => {
    if (event.key === ENTER) {
      if (!disabled && handleKeyDown) {
        handleKeyDown();
        event.target.blur();
      }
    }
  };

  const commonProps = {
    id: inputId,
    value: value,
    onChange: onChange,
    placeholder: placeholder,
    autoFocus: autoFocus,
    required: required,
    maxLength: maxLength,
    disabled: disabled,
    onKeyDown: handleKeyEvents,
    inputMode: inputMode,
    readOnly: !editable,
    className: `${(className && className.trim()) ? className : 'emailInput'} ${hasError ? 'input-error' : ''} ${placeholderClass || ''}`
  };

  return (
    <>
      {multiline ? (
        <textarea {...commonProps} rows={rows} />
      ) : (
        <>
        {customer !== HIVEBOARD &&
        <p className='email-paragraph'> {text ? text : ''}</p> }
        <div className='input-with-icon-wrapper'>
          <input {...commonProps} type={type} />
          {endIcon && (
            <span className='input-end-icon' onClick={onEndIconClick}>
              {endIcon}
            </span>
          )}
        </div>
        </>
      )}

      {errorMessage && (
        <p className="reason-validation-error">{errorMessage}</p>
      )}
    </>
  );
};